/**
 * @description Renders the form's footer in the footer section of the application page.
 */

import styled from '@mui/system/styled';
import Box from '@mui/material/Box';

const FooterContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  border: 0,
  borderColor: theme.palette.grey['400'],
  borderStyle: 'solid',
  borderTopWidth: 1,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '1rem',
  padding: '1rem',
  width: '100%'
}));

export const FooterContainerWithLeftAside = styled(FooterContainer)(() => ({
  gap: 0,
  justifyContent: 'space-between'
}));

export default FooterContainer;
